export default __webpack_public_path__ + "static/media/notification.2e1bb7b2.svg";